import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import EditDueAmountWrapper from "../Edit/EditDueAmountWrapper";
import DueAmountListing from "./Dashboard2Listing";
import { useGetDueAmountReportQuery } from "src/services/DashboardService";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const DueAmountListingWrapper = (props: Props) => {
  const [items, setItems] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  const [selectedDueAmountId, setSelectedDueAmountId] = useState<string>("");
// const today = new Date();
// const formattedToday = `${today.getFullYear()}-${String(
//   today.getMonth() + 1
// ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const { data, isLoading, isFetching } = useGetDueAmountReportQuery({
    // Your query parameters here
    limit: 10,
    searchValue: "",
    params: ["name", "email", "mobile", "orderId"],
    page: 1,
    filterBy: [
      {
        fieldName: "",
        value: [],
      },
    ],
    dateFilter: {
      startDate:"", 
      endDate: "",
      dateFilterKey: "",
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    setItems(data?.data || []);
    setIsTableLoading(isLoading || isFetching);
  }, [data, isLoading, isFetching]);

  const moduleName = "ORDER";

  const canEdit = usePermission(moduleName, "UPDATE");

  const columns: columnTypes[] = [
    { field: "orderNumber", headerName: "Order Number", flex: "flex-[1_1_0%]" },
    { field: "name", headerName: "Student Name", flex: "flex-[1_1_0%]" },
    { field: "mobile", headerName: "Mobile Number", flex: "flex-[1_1_0%]" },
    { field: "dueAmt", headerName: "Due Amount", flex: "flex-[1_1_0%]" },
    { field: "duedate", headerName: "Due Date", flex: "flex-[1_1_0%]" },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              setIsOpenEditDialog(true);
              setSelectedDueAmountId(row?._id);
            },
          });
        }

        return <ATMMenu options={options} />;
      },
    },
  ];

  return (
    <>
      <div>
        <DueAmountListing
          columns={columns}
          rows={items}
          isTableLoading={isTableLoading}
        />
      </div>

      {isOpenEditDialog && (
        <EditDueAmountWrapper
          onClose={() => setIsOpenEditDialog(false)}
          selectedDueAmountId={selectedDueAmountId}
        />
      )}
    </>
  );
};

export default DueAmountListingWrapper;
